import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout7 } from "../RowBox";
import { DivHover, DivHelp } from "./styled";

class Row7 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="RowCarousel" />
        {this.state.hover && <DivHelp>Row Carousel</DivHelp>}
      </DivHover>
    );
  }
}

Row7.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

Row7.defaultProps = {
  childOf: "Row",
  values: {
    name: "Row7",
    parent: "Body",
    type: "Row",
    backgroundColor: "rgba(255,255,255,0)",
    backgroundImage: {
      url: "",
      urlMobile: ""
    },
    bgProps: {
      size: "cover",
      position: "center",
      repeat: "no-repeat",
      ratio: 1.2
    },
    align: "center",
    isBackgroundImage: false,
    padding: "0px",
    width: {
      type: "%",
      contentWidth: 100
    },
    carousel: {
      keyActive: "",
      auto: false,
      direaction: "incremental",
      interval: 3
    }
  },
  content: [
    {
      type: "ContentCarousel",
      props: {
        values: {
          parent: "Row",
          type: "ContentCarousel",
          className: "col-xs-12",
          column: 1,
          backgroundColorParent: "rgba(255,255,255,0)",
          backgroundColor: "rgba(255,255,255,0)",
          backgroundImage: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0
            },
            mobile: {
              width: 0,
              height: 0
            }
          },
          bgProps: {
            size: "cover",
            position: "center",
            repeat: "no-repeat",
            ratio: 1.2
          },
          isBackgroundImage: false,
          padding: "0px",
          width: {
            type: "%",
            contentWidth: 100
          },
          alignment: {
            vertical: "center",
            horizontal: "center"
          }
        }
      },
      children: [],
      childOf: "Row"
    }
  ],
  layout: Layout7
};
export default Row7;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Row/Row7.js